import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { updateLowStock } from "../../../api/lowStockApi";
import PropTypes from "prop-types";
import { getAllWarehouses } from "../../../api/warehouseApi";
import { getAllStores } from "../../../api/storeApi";
// import api from "api";
import { toast } from "react-toastify";
import { api } from "../../../api/client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const EditLowStock = ({ selectedVariant }) => {
  const [quantity, setQuantity] = useState(selectedVariant?.qty || 0);
  const [quantityAlert, setQuantityAlert] = useState(selectedVariant?.qtyalert || 0);
  const [warehouse, setWarehouse] = useState(selectedVariant?.warehouse || null);
  const [store, setStore] = useState(selectedVariant?.store || null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);

  const fetchProductsByStore = async (storeId, warehouseId) => {
    try {
      await api.get(`${API_BASE_URL}api/products/by-warehouse/${warehouseId}`);
      // Note: product list is not used in this modal, so nothing to set
    } catch (err) {
      toast.error(`${window.translate("Failed to fetch products")}`);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [warehouses, stores] = await Promise.all([
          getAllWarehouses(),
          getAllStores(),
        ]);

        const formattedWarehouses = warehouses.map((wh) => ({
          label: wh.warehouse,
          value: wh.id,
        }));

        const formattedStores = stores.map((st) => ({
          label: st.CustomerName,
          value: st.id,
        }));

        setWarehouseOptions(formattedWarehouses);
        setStoreOptions(formattedStores);
      } catch (err) {
        toast.error(`${window.translate("Failed to load warehouses or stores")}`);
      }
    };

    fetchInitialData();
  }, []);

const handleSave = async () => {
  try {
    await updateLowStock(selectedVariant._id, {
      quantity: parseInt(quantity),
      quantityAlert: parseInt(quantityAlert),
      source: selectedVariant?.source || "ProductVariant", // fallback if missing
    });
    // toast.success("Low stock updated");
    toast.success(`${window.translate("Low stock updated")}`)
    // Optionally, you can refresh the data or close the modal here
    document.getElementById("close-add-stock-btn")?.click();

      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
  } catch (err) {
    toast.error(`${window.translate("Failed to update low stock")}`);
    console.error("Update failed:", err);
  }
};

  return (
    <>
      <div className="modal fade" id="edit-stock">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header">
                  <div className="page-title">
                    <h4>{window.translate("Edit Low Stocks")}</h4>
                  </div>
                  <button
                    type="button"
                    className="close bg-danger text-white fs-16"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true" className="fs-16">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="row">
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("Warehouse")}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <Select
                          options={warehouseOptions}
                          value={warehouseOptions.find(w => w.value === warehouse)}
                          onChange={async (e) => {
                            setWarehouse(e.value);
                            if (store) await fetchProductsByStore(store, e.value);
                          }}
                          placeholder="Select Warehouse"
                        />
                      </div>
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("Store")}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <Select
                          options={storeOptions}
                          value={storeOptions.find(s => s.value === store)}
                          onChange={async (e) => {
                            setStore(e.value);
                            if (warehouse) await fetchProductsByStore(e.value, warehouse);
                          }}
                          placeholder="Select Store"
                        />
                      </div>
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("SKU")}
                          <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedVariant?.sku || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("Category")}<span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedVariant?.category || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-12 mb-3">
                        <label className="form-label">
                          {window.translate("Product Name")}<span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={selectedVariant?.product || ""}
                          readOnly
                        />
                      </div>
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("Qty")}<span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={quantity}
                          onChange={(e) => setQuantity(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-6 mb-3">
                        <label className="form-label">
                          {window.translate("Qty Alert")}<span className="text-danger ms-1">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          value={quantityAlert}
                          onChange={(e) => setQuantityAlert(e.target.value)}
                        />
                      </div>
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn me-2 btn-secondary fs-13 fw-medium p-2 px-3 shadow-none"
                    data-bs-dismiss="modal"
                  >
                    {window.translate("Cancel")}
                  </button>
                  <Link
                    data-bs-dismiss="modal"
                    to="#"
                    className="btn btn-primary fs-13 fw-medium p-2 px-3"
                    onClick={handleSave}
                  >
                    {window.translate("Save Changes")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

EditLowStock.propTypes = {
  selectedVariant: PropTypes.shape({
    _id: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    quantityAlert: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    qty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    qtyalert: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    product: PropTypes.string,
    productName: PropTypes.string,
    sku: PropTypes.string,
    category: PropTypes.string,
    warehouse: PropTypes.string,
    store: PropTypes.string,
    source: PropTypes.oneOf(["ProductVariant", "ProductPricingStock"]),
  }),
};

export default EditLowStock;
